import { Component, OnInit } from '@angular/core';
import { Router, NavigationEnd, NavigationStart } from '@angular/router';
import { Subscription } from 'rxjs/Subscription';
import Darkmode from 'darkmode-js';

@Component({
  selector: 'app-my-app',
  templateUrl: './app.component.html'
})

export class AppComponent implements OnInit {
  private _router: Subscription;

  constructor(private router: Router) {
    
    // var options = {
    //   bottom: '64px', // default: '32px'
    //   right: 'unset', // default: '32px'
    //   left: '32px', // default: 'unset'
    //   time: '0.5s', // default: '0.3s'
    //   mixColor: '#fff', // default: '#fff'
    //   backgroundColor: '#fff',  // default: '#fff'
    //   buttonColorDark: '#100f2c',  // default: '#100f2c'
    //   buttonColorLight: '#fff', // default: '#fff'
    //   saveInCookies: false, // default: true,
    //   label: '🌓', // default: ''
    //   autoMatchOsTheme: true // default: true
    // }
    
    // const darkmode = new Darkmode(options);
    // darkmode.showWidget();
  }

  ngOnInit() {
    this._router = this.router.events.filter(event => event instanceof NavigationEnd).subscribe((event: NavigationEnd) => {
      const body = document.getElementsByTagName('body')[0];
      const modalBackdrop = document.getElementsByClassName('modal-backdrop')[0];
      if (body.classList.contains('modal-open')) {
        body.classList.remove('modal-open');
        modalBackdrop.remove();
      }
    });
  }
}
